export enum ApiResponseStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
